import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=4d12a84b"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"
import style0 from "./Summary.vue?vue&type=style&index=0&id=4d12a84b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports